<template>
  <div id="app">
    <div class="main" :class="ismove?'move':''">
      <div class="header">
        <div class="flex" v-show="!iframe.open">
          <div class="nav button" @click="ismove=!ismove">
            <img src="@/assets/nav-icon.png" alt="nav" />
          </div>
          <div>{{search?search+'的搜索结果':data.title}}</div>
          <div class="search button" @click="issearch=!issearch">
            <img src="@/assets/search-icon.png" alt="search" />
          </div>
        </div>
        <div class="flex" v-show="iframe.open">
          <div class="nav button" @click="iframe.open=false">
            <img src="@/assets/back-icon.png" alt="nav" />
          </div>
          <div>{{iframe.title}}</div>
        </div>
      </div>
      <div class="searchinput flex" v-show="issearch">
        <input v-model="search" v-on:input="getsearch" placeholder="请输入关键词" />
      </div>
      <div class="shelf" :class="issearch?'height2':''">
        <div class="shelf-in flex">
          <div class="book" v-for="(item, index) in sdata" :key="index" @click="iframeOpen(item)">
            <img
              :src="item.img?item.img:item.src.replace('index.html', '')+'files/mobile/1.jpg'"
              alt
            />
            <div class="book-name">{{item.name}}</div>
          </div>
          <div class="embook" v-for="(item, index) in 10" :key="index+'空'"></div>
        </div>
      </div>
      <div class="footer flex">
        <div class="button">共{{data.list.length}}本</div>
        <div class="contact" @click="iscontact=true">电子样本制作</div>
      </div>
      <div class="contact-box flex" :class="iscontact?'move3':''">
        <div class="button" @click="iscontact=false">
          <img src="@/assets/down-icon.png" alt="search" />
        </div>
        <div>制作电子样本请拨打：18058336622</div>
        <div class="button">
          <a href="tel:18058336622"><img src="@/assets/phone-icon.png" alt="search" /></a>
          
        </div>
      </div>
    </div>
    <div class="leftbox">
      <div class="flex title">
        <img src="@/assets/book-icon.png" />样本列表
      </div>

      <div class="nav">
        <a
          @click="iframeOpen(item)"
          v-for="(item,index) in data.list"
          :key="index"
          target="_blank"
        >{{item.name}}</a>
      </div>
    </div>
    <div class="book-info" :class="iframe.open?'move2':''">
      <vue-friendly-iframe :src="iframe.src"></vue-friendly-iframe>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {
        list: [],
        title: "",
      },
      ismove: false,
      issearch: false,
      iscontact: false,
      search: "",
      sdata: [],
      iframe: { src: "", title: "", open: false },
    };
  },
  created() {
    this.$axios({
      method: "get",
      url: "./data.json",
    }).then((res) => {
      this.data = res.data;
      this.sdata = res.data.list;
    });
  },
  methods: {
    //  点击搜索工程
    getsearch() {
      let that = this;
      let searchdata = [];
      that.data.list.map(function (item) {
        if (item.name.search(that.search.toUpperCase()) !== -1) {
          searchdata.push(item);
        }
      });
      that.sdata = searchdata;
    },
    iframeOpen(item) {
      this.iframe.src = item.src;
      this.iframe.title = item.name;
      this.iframe.open = true;
      this.ismove = false;
    },
  },
};
</script>

<style lang="scss">
body {
  margin: 0;
}

#app {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #f1f1f1;
  position: relative;
  img {
    max-width: 100%;
    vertical-align: middle;
  }
  a {
    text-decoration: none;
    display: block;
  }
  .flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .button {
    box-shadow: 0 1px 1px #f4f4f4 inset;
    border: 1px solid #878787;
    background-color: #dbdbdb;
    background-image: linear-gradient(
      to top,
      #c9c9c9 0,
      #dbdbdb 50%,
      #e5e5e5 100%
    );
    border-radius: 20px;
    img {
      padding: 2px 10px;
    }
  }
}
.move {
  left: 260px !important;
}
.move2 {
  left: 0 !important;
}
.move3 {
  bottom: 0 !important;
}
.height2 {
  height: calc(100% - 56px - 54px - 35px) !important;
}
.leftbox {
  width: 204px;
  height: calc(100% - 28px - 28px);
  position: absolute;
  top: 0;
  left: 0;
  background-color: #000;
  color: #ebebeb;
  padding: 28px;
  font-size: 20px;
  .title {
    justify-content: flex-start !important;
    img {
      margin-right: 10px;
    }
  }
  .nav {
    margin-top: 10px;
    max-height: 94%;
    overflow: auto;
    a {
      color: #fff;
      font-size: 12px;
      margin-top: 8px;
    }
  }
}
.main {
  background: #fff;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  transition: all 0.5s;
  left: 0;
  right: 0;
}
.header {
  background: url("./assets/top-nav.jpg");
  color: #fff;
  padding: 15px 5px;
  font-size: 16px;
}
.searchinput {
  background: #fff;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.3) inset !important;

  input {
    border: none;
    padding: 10px;
    background: none;
    width: 100%;
    outline: none;
  }
}
.shelf {
  height: calc(100% - 56px - 54px);
  background: url("./assets/bg.jpg");
  overflow: auto;

  .shelf-in {
    flex-wrap: wrap;
    background: url("./assets/bg.jpg");
    padding: 0 20px;
    align-items: flex-start !important;
    .book {
      width: 152px;
      height: 152px;
      text-align: center;
      position: relative;
      background: url("./assets/book.png");
      img {
        width: 80px;
        margin-top: 36px;
      }
      .book-name {
        position: absolute;
        bottom: 8px;
        width: calc(100% - 8px);
        text-align: center;
        font-size: 14px;
        color: #525252;
        background: url("./assets/bookname.png");
        padding: 4px;
        box-shadow: 2px 0px 2px 0px #bbb;
      }
    }
    .embook {
      width: 152px;
    }
  }
}
.footer {
  background: url("./assets/top-nav.jpg");
  justify-content: center !important;
  padding: 10px 0;
  position: relative;
  .contact {
    position: absolute;
    color: #fff;
    right: 10px;
    font-size: 14px;
  }
  .button {
    padding: 5px 10px;
    background-color: #fff !important;
    background-image: none !important;
    box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.3) inset !important;
  }
}
.contact-box {
  position: absolute;
  bottom: -59px;
  z-index: 999;
  width: 100%;
  background: url("./assets/top-nav.jpg");
  color: #fff;
  padding: 12px 0;
  transition: all 0.5s;
}
.book-info {
  position: absolute;
  z-index: 2;
  width: 100%;
  height: calc(100% - 56px);
  bottom: 0;
  transition: all 0.5s;
  left: 100vw;
  background: #fff;
  iframe {
    width: 100%;
    height: calc(100vh - 56px);
  }
}
</style>